import React from "react";

const ServiceTimeBasedHover = () => {
  return (
    <>
      <svg
        width="120"
        height="129"
        viewBox="0 0 167 179"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_46692_101518)">
          <path d="M1 1H166V178H1V1Z" fill="white" />
          <path
            d="M147.378 110.457H18.7559V104.61C18.7559 98.7638 23.5196 94 29.3661 94H136.984C142.614 94 147.378 98.5472 147.378 104.394V110.457Z"
            fill="#EEEEEE"
          />
          <path
            d="M18.7559 63H43.6574M18.7559 74.0433H43.6574"
            stroke="#044E97"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.1514 94.2266H137.203C142.832 94.2266 147.38 98.7738 147.38 104.404V151.608C147.38 157.238 142.832 161.786 137.203 161.786H29.1514C23.5215 161.786 18.9742 157.238 18.9742 151.608V104.62C18.7577 98.7738 23.3049 94.2266 29.1514 94.2266Z"
            stroke="#044E97"
            stroke-miterlimit="10"
          />
          <path
            d="M31.5337 41.6572C38.4698 41.6572 44.0927 36.0343 44.0927 29.0981C44.0927 22.1619 38.4698 16.5391 31.5337 16.5391C24.5975 16.5391 18.9746 22.1619 18.9746 29.0981C18.9746 36.0343 24.5975 41.6572 31.5337 41.6572Z"
            stroke="#044E97"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M125.076 24.1172V33.6447H123.127V24.1172H125.076ZM135.469 24.1172V33.6447H133.737L129.623 27.7983V33.6447H127.674V24.1172H129.406L133.521 29.9636V24.1172H135.469ZM139.584 24.1172L141.966 31.2629L144.347 24.1172H146.513L143.265 33.6447H140.666L137.418 24.1172H139.584Z"
            fill="#71778E"
          />
          <path
            d="M70.7268 162.202V94.8594M19.1914 110.233H147.164"
            stroke="#044E97"
            stroke-miterlimit="10"
          />
        </g>
        <rect
          x="0.5"
          y="0.5"
          width="166"
          height="178"
          rx="16.5"
          stroke="#044E97"
        />
        <defs>
          <clipPath id="clip0_46692_101518">
            <rect x="1" y="1" width="165" height="177" rx="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default ServiceTimeBasedHover;
